"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridElement = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const Theme_1 = require("../Theme");
const getMarginInlineStyle = (gutter) => {
    return `-${gutter / 2}px`;
};
const getInitialMarginInlineEndStyle = (margin, gutter) => {
    return `${margin - gutter / 2}px`;
};
const getInitialMarginInlineStartStyle = (maxWidth, margin, gutter) => {
    const gutterPadding = gutter / 2;
    return `max(50vw - (${gutterPadding + maxWidth / 2}px), ${margin - gutterPadding}px)`;
};
const GridElement = (_a) => {
    var { fillGapEnd, fillGapStart, initial, sx, variant, wrap } = _a, props = __rest(_a, ["fillGapEnd", "fillGapStart", "initial", "sx", "variant", "wrap"]);
    const theme = (0, Theme_1.useThemeWithoutTypes)();
    const styles = react_1.default.useMemo(() => {
        const { sizes: { containerDesktopMargin, containerDesktopMaxWidth, containerMobileMargin, containerMobileMaxWidth, containerTabletMargin, containerTabletMaxWidth, gridDesktopColumnGutter, gridMobileColumnGutter, gridTabletColumnGutter } } = theme;
        return {
            boxSizing: "border-box",
            display: "flex",
            flexGrow: 1,
            flexWrap: wrap ? "wrap" : "nowrap",
            justifyContent: "flex-start",
            marginInlineEnd: initial
                ? [
                    getInitialMarginInlineEndStyle(containerMobileMargin, gridMobileColumnGutter),
                    getInitialMarginInlineEndStyle(containerTabletMargin, gridTabletColumnGutter),
                    getInitialMarginInlineEndStyle(containerDesktopMargin, gridDesktopColumnGutter)
                ]
                : [
                    getMarginInlineStyle(gridMobileColumnGutter),
                    getMarginInlineStyle(gridTabletColumnGutter),
                    getMarginInlineStyle(gridDesktopColumnGutter)
                ],
            marginInlineStart: initial
                ? [
                    getInitialMarginInlineStartStyle(containerMobileMaxWidth, containerMobileMargin, gridMobileColumnGutter),
                    getInitialMarginInlineStartStyle(containerTabletMaxWidth, containerTabletMargin, gridTabletColumnGutter),
                    getInitialMarginInlineStartStyle(containerDesktopMaxWidth, containerDesktopMargin, gridDesktopColumnGutter)
                ]
                : [
                    getMarginInlineStyle(gridMobileColumnGutter),
                    getMarginInlineStyle(gridTabletColumnGutter),
                    getMarginInlineStyle(gridDesktopColumnGutter)
                ],
            maxWidth: variant === "primary" && initial
                ? [
                    `${containerMobileMaxWidth + gridMobileColumnGutter}px`,
                    `${containerTabletMaxWidth + gridTabletColumnGutter}px`,
                    `${containerDesktopMaxWidth + gridDesktopColumnGutter}px`
                ]
                : "none",
            paddingInlineEnd: [
                fillGapEnd ? `${theme.sizes.gridMobileColumnGutter}px` : 0,
                fillGapEnd ? `${theme.sizes.gridTabletColumnGutter}px` : 0,
                fillGapEnd ? `${theme.sizes.gridDesktopColumnGutter}px` : 0
            ],
            paddingInlineStart: [
                fillGapStart ? `${theme.sizes.gridMobileColumnGutter}px` : 0,
                fillGapStart ? `${theme.sizes.gridTabletColumnGutter}px` : 0,
                fillGapStart ? `${theme.sizes.gridDesktopColumnGutter}px` : 0
            ],
            // Hack so the grid renders well in the Storybook docs
            ".docs-story &": initial
                ? {
                    marginInlineEnd: "auto",
                    marginInlineStart: "auto"
                }
                : null
        };
    }, [fillGapEnd, fillGapStart, initial, theme, variant, wrap]);
    return (react_1.default.createElement(__1.Box, Object.assign({ sx: Object.assign(Object.assign({}, sx), styles
        // This element requires calculated sizing values and can't use
        // the Box sx props from the theme.
        ) }, props)));
};
exports.GridElement = GridElement;
//# sourceMappingURL=GridElement.js.map